import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import './styles/globals.css';

// Apply saved theme before first paint to avoid FOUC
(function applyStoredTheme() {
  try {
    const raw = localStorage.getItem('theme-v2');
    if (raw) {
      const parsed = JSON.parse(raw) as { state?: { appTheme?: string } };
      const appTheme = parsed?.state?.appTheme;
      if (appTheme) {
        document.documentElement.dataset.theme = appTheme;
        if (appTheme === 'oled' || appTheme === 'catppuccin-mocha' || appTheme === 'dark') {
          document.documentElement.classList.add('dark');
        } else if (appTheme === 'light') {
          document.documentElement.classList.remove('dark');
        }
        return;
      }
    }
    // Fallback: system preference
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      document.documentElement.classList.add('dark');
    }
  } catch { /* ignore */ }
})();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
